import $ from 'jquery';
import 'jscroll';
import 'jquery-hammerjs';
import Hammer from 'hammerjs';

import assign from 'lodash/object/assign';
import bindAll from 'lodash/function/bindAll';

import BackgroundSlider from './components/BackgroundSlider';
import Facebook from './components/Facebook';
import { LoadingIndicator } from './components/jscroll-spin';

export default class PortalPage {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.$el = $('body');

        bindAll(this, [
            'clickBtnNextExhibition',
            'clickBtnPrevExhibition',
            'carouselNavClickHandler',
            'carouselSwipeHandler'
        ]);

        this.backgroundSlider = new BackgroundSlider.BackgroundSlider({
            $el: $('#hero')
        });

        $('.fb-share').each(function (index, item) {
            var fb = new Facebook.Facebook({
                $el: $(this),
                link: $(this).data('fb-link')
            });
        });

        this.$carouselItems = $('.js-carousel-nav a');
        this.activeItem = 0;
        this.bindEvents();
        this.moveCarousel(undefined, 0);

        this.loadingIndicator = new LoadingIndicator();
        this.setupInfiniteScrolling();
    }

    bindEvents() {
        this.$el.on('click', '.js-btn-next-exhibition', this.clickBtnNextExhibition);
        this.$el.on('click', '.js-btn-prev-exhibition', this.clickBtnPrevExhibition);
        this.$el.on('click', '.js-carousel-nav a', this.carouselNavClickHandler);

        this.$el.find('.js-hero').hammer().on('swipe', this.carouselSwipeHandler);
    }

    carouselSwipeHandler(event) {
        var direction = 'previous';

        if (event.gesture.direction & Hammer.DIRECTION_HORIZONTAL) {
            if (event.gesture.direction === Hammer.DIRECTION_LEFT) {
                direction = 'next';
            }

            this.moveCarousel(direction);
        }
    }

    carouselNavClickHandler(event) {
        var clickedIndex = this.$carouselItems.index(event.currentTarget),
            direction = 'next';

        if (clickedIndex !== this.activeItem) {
            if (clickedIndex < this.activeItem) {
                direction = 'previous';
            }

            this.moveCarousel(direction, clickedIndex);
        }
    }

    getRelativeCarouselItemIndex(relation) {
        var activeItem = this.activeItem,
            relativeItem;

        relativeItem = activeItem + 1;
        if (relation === 'previous') {
            if (activeItem === 0) {
                relativeItem = this.$carouselItems.length - 1;
            } else {
                relativeItem = this.activeItem - 1;
            }
        } else if (activeItem === this.$carouselItems.length - 1) {
            relativeItem = 0;
        }

        return relativeItem;
    }

    moveCarousel(direction, itemIndex) {
        if (this.backgroundSlider.model.get('sliding') !== true) {
            itemIndex = itemIndex !== undefined ? itemIndex : this.getRelativeCarouselItemIndex(direction);

            var self = this,
                $carouselInfo = self.$el.find('.js-carousel-info > div'),
                $item = $(this.$carouselItems[itemIndex]),
                $titleWrap = self.$el.find('.js-carousel-title');

            $titleWrap.stop().animate({
                opacity: 0
            }, 300);

            this.backgroundSlider.slideToNewBackgroundImage(direction, $item.data('image-url'), function () {
                $titleWrap.html($item.data('info-text')).append($('<strong />').text($item.text()));

                $('.js-btn-view-exhibition.virtual')
                    .attr('href', $item.data('exhibition-url-virtual'))
                    .toggle(!!$item.data('exhibition-url-virtual'));

                $('.js-btn-view-exhibition.physical')
                    .attr('href', $item.data('exhibition-url-physical'))
                    .toggle(!!$item.data('exhibition-url-physical'));

                self.$carouselItems.removeClass('active');
                $item.addClass('active');

                self.activeItem = itemIndex;

                $titleWrap.stop().animate({
                    opacity: 1
                }, 500);
            });
        }
    }

    clickBtnNextExhibition() {
        this.moveCarousel('next');
    }

    clickBtnPrevExhibition() {
        this.moveCarousel('previous');
    }

    setupInfiniteScrolling() {
        this.$el.find('#exhibition-list').jscroll({
            // This kinda sucks, but jscroll doesn't provide a callback to run
            // js to create loading HTML so we'll have to make our own callback
            // by inserting a script tag which calls our function.
            loadingHtml: this.loadingIndicator.getScriptTagHtml(),
            nextSelector: '.navi .js-next-link a',
            contentSelector: '#exhibition-list > *',
            callback: () => this.loadingIndicator.removeSpinner()
        });
    }
}



/** WEBPACK FOOTER **
 ** ./js/view/PortalPage.js
 **/